import { createAction } from 'redux-actions';

export const fetchAllContexts = createAction('FETCH_ALL_CONTEXTS');
export const fetchAllContextsSuccess = createAction('FETCH_ALL_CONTEXTS_SUCCESS');
export const fetchAllContextsFailure = createAction('FETCH_ALL_CONTEXTS_FAILURE');
